import React, { useContext } from 'react';
import { Statistic as AntdStatistic } from 'antd';
import { ApplicationUIContext } from '../Provider/Provider';
import styled from 'styled-components';

const StyledStatistic = styled(AntdStatistic)`
  .ant-statistic-title {
    font-size: ${({ isMobile }) => (isMobile ? 16 : 14)}px;
  }
`;

const StatsValueStyle = (isMobile) => ({
  display: 'flex',
  justifyContent: isMobile ? 'left' : 'center',
  fontSize: isMobile ? 16 : 14,
});

const Statistic = (props) => {
  const { isMobile } = useContext(ApplicationUIContext);

  return <StyledStatistic {...props} isMobile={isMobile} valueStyle={StatsValueStyle(isMobile)} />;
};

export { Statistic };
